<div>
    <div class="dcp-custom-form dcp p-2">
        <div class="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
            <h2 class="mb-0">Merge Accounts</h2>
            <div class="btn-light btn-position" (click)="closeModal()" [class.disabled]="mergeLoader">
                <span class="mat-icon material-icons">close</span>
            </div>
        </div>

        <h5 class="text-black-50 mb-4">
            Please select the profile to merge <span class="text-dark"> {{ data?.item?.email || 'account' }} </span> with:
        </h5>

        <form class="position-relative mb-3" [formGroup]="searchForm">
            <div class="search">
                <img src="assets/images/icons/dashboard_search_icon.png" alt="search icon" class="search-icon" />
                <input type="text" class="form-control w-100 marginl" placeholder="Search by name"
                    formControlName="search" />
            </div>
        </form>

        <div>
            <table class="table mb-5" aria-describedby="Users table">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Provider</th>
                        <th>DOB</th>
                        <th>Province</th>
                        <th>Managed by</th>
                    </tr>
                </thead>

                <!-- loader row -->
                <tbody *ngIf="progress_spinner">
                    <tr>
                        <td colspan="7">
                            <div class="w-100 d-flex align-items-center justify-content-center">
                                <span class="purpleLoader"></span>
                            </div>
                        </td>
                    </tr>
                </tbody>

                <!-- data row -->
                <tbody *ngIf="!progress_spinner && response.length > 0">
                    <tr *ngFor="let user of response">
                        <td>
                            <mat-radio-group [(ngModel)]="selectedUserId" (change)="onUserSelect(user)">
                                <mat-radio-button [value]="user.id"></mat-radio-button>
                            </mat-radio-group>
                        </td>
                        <td>{{ user.firstName }} {{ user.lastName }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.provider_name }}</td>
                        <td>{{ user.dob }}</td>
                        <td>{{ user.user_province?.state_name }}</td>
                        <td>{{ user.managed_by || 'Self' }}</td>
                    </tr>
                </tbody>

                <!-- no data row -->
                <tbody>
                    <tr *ngIf="!progress_spinner && response.length == 0">
                        <td colspan="7" class="text-center text-muted">
                          {{ dataFound ? 'Enter a user\'s email or name to start searching.' : 'No users found with that email or name.'  }}
                        </td>
                      </tr>
                </tbody>
            </table>
        </div>

        <div class="text-black-50 mb-4" *ngIf="selectedUserId">
            <h5><span class="text-dark">Please note:</span>  The following data will be transferred from the account <span class="text-dark"> {{ data?.item?.email || 'source user' }} </span> to <span class="text-dark"> {{ selectedEmail || 'transfer user' }} </span>:</h5>
            <ul class="text-dark">
                <li>Sales Orders</li>
                <li> Saved Addresses</li>
                <li>Benefits (up to 5 entries)</li>
                <li>Allergies</li>
                <li>Medical Conditions</li>
                <li>Notes</li>
                <li>Consultations</li>
                <li>etc.</li>
              </ul>
        </div>
          
        <div class="check-box-outer mb-4">
            <div class="form-group e-section">
                <mat-checkbox class="e-margin" [(ngModel)]="isCheckboxChecked">
                    I understand that account information will be merged and only selected profile above will have
                    access. this action cannot be undone.
                </mat-checkbox>
            </div>
        </div>

        <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-outline-primary" [disabled]="mergeLoader" (click)="closeModal()">Cancel</button>
            <button class="btn btn-primary" (click)="merge_process(selectedUserId)" [disabled]="!selectedUserId || !isCheckboxChecked || mergeLoader">
                {{mergeLoader ? 'Merging...' :'Merge Accounts' }}
            </button>
        </div>
    </div>
</div>